<template>
  <b-overlay id="overlay-background" class="overlay-config" :show="loading" rounded="sm" >
    <div>
      <div class="sample1 grid middle"></div>
      <div class="row">
        <b-col class="gridBtGroup rowItem" xl="1" lg="3" md="3" sm="3">
          <img
            v-if="!saving"
            src="@/assets/salvar.png"
            :alt="$t('salvar')"
            style="margin-left: 30px; height:38px; cursor:pointer;"
            :title="$t('salvar')"
            @click="sendWeight($event)"
          />
          <b-spinner v-else class="spinner" label="Loading..."></b-spinner>
          <img
            src="@/assets/cancel.png"
            :alt="$t('cancelar')"
            style="margin-left: 30px; height:38px; cursor:pointer;"
            :title="$t('cancelar')"
            @click="$bvModal.show('confirmWeightRestore')"
          />
        </b-col>
      </div>
      <b-modal id="confirmWeightRestore" ok-variant="danger" 
      :title="$t('atencao')"
      :ok-title="$t('yes')"
      :cancel-title="$t('no')"
      @ok="reset">
        {{ $t('confirma-o-descarte-das-alteracoes-2') }} </b-modal>

      <b-modal id="waitWeight" hide-footer>
        <p>{{ $t('aguarde-o-carregamento-dos-dados') }}</p>
        <!-- <b-progress :value="value" :max="100" show-progress animated></b-progress> -->
      </b-modal>

      <b-modal
      id="showProductPlainItem"
      size="md"
      hide-footer
      :title="$t('selecione-uma-variavel-do-plano-de-safra')"
      :no-close-on-backdrop="true"
    >
    <SelectProductPlainItem
      :getItemSelected="productPlainItemSelected.indicatorPlan"
      @productSelected="setProductPlainItem"
    
     />
    </b-modal>
    
    <b-modal
      id="showListGreatness"
      size="md"
      hide-footer
      :title="$t('selecione-uma-grandeza')"
      :no-close-on-backdrop="true"
    >
    <SelectGreatness
      :getItemSelected="productPlainItemSelected.indicatorPlan"
      @greatnessSelected="setProductPlainItem"
    />
    </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import {mapState} from "vuex";
import axios from "axios";
import SelectGreatness from "../kpiConfiguration/SelectGreatness.vue";
import SelectProductPlainItem from "../kpiConfiguration/SelectProductPlainItem.vue";
import TableWeightIndicator from "./TableWeightIndicator"

export default {
  name: "GridWeightIndicator",

  components: {
    ...cGridAll,
    SelectGreatness,
    SelectProductPlainItem,
  },

  computed: mapState(["msg"]),

  watch: {
    role() {
      this.loadWeight();
    },
  },

  props: ["role"],

  data: function() {
    return {
      value: 0,
      loading: false,
      saving: false,
      temp: [],
      header: TableWeightIndicator.header,
      json: [],
      productPlainItemSelected:{},

    };
  },

  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      dateBr = dateBr.split(" ")[0];
      if (dateBr == "Invalid") {
        return "";
      } else {
        return dateBr;
      }
    },
  },

  methods: {
    setProductPlainItem(value){
      this.productPlainItemSelected.indicatorPlan = value 
    },

    onClickRecord(rec) {
      alert(JSON.stringify(rec));
    },

    async loadWeight() {
      this.loading = true
       defaultSuccess(this.$t('carregando-dados'));
      const url = `${urlMainAPI}/getindicatorconfigurationdata`;
      await axios.get(url).then((res) => {
        this.json = res.data;
        this.temp = JSON.parse(JSON.stringify(this.json));
        this.setGrid();
         defaultSuccess(this.$t('dados-carregados'));
        this.loading = false
      }).catch((error) => {
        console.error(error)
        defaultSuccess(this.$t('uma-nova-tentativa-iniciara-em-5-segundos'))
        setTimeout(() => this.loadWeight(), 5000);
      });
    },

    canSave(){
      let hasError = false;
      var parseNumber = (num) => parseFloat(String(num).replace(",", "."))

      this.json.forEach(w => {
        if(parseNumber(w.lowerLimit) > parseNumber(w.upperLimit))
          hasError = true

        if((isNaN(parseFloat(w.lowerLimit)) && w.lowerLimit != null) && w.lowerLimit != '')
          hasError = true
          
        if((isNaN(parseFloat(w.upperLimit)) && w.upperLimit != null) && w.upperLimit != '')
          hasError = true

        if((isNaN(parseFloat(w.weight)) && w.weight != null) && w.weight != '')
          hasError = true
      })
      return hasError;
    },

    // eslint-disable-next-line no-unused-vars
    sendWeight: async function(e) {
      defaultSuccess(this.$t('salvando-dados-isso-pode-demorar-um-pouco'));
      if(this.canSave()){
        showError(this.$t('ha-algum-problema-ao-salvar-verifique-as-mensagens-de-erros-na-tabela'))
        return 
      }
      this.saving = true;
      
      const url = `${urlMainAPI}/saveindicatorconfigurationdata`;
      await axios
        .post(url, this.json)
        .then((res) => {
          defaultSuccess(res.data);
          this.temp = JSON.parse(JSON.stringify(this.json));
        })
        .catch(console.error);

        this.saving = false;
    },    

    reset() {
        this.json = JSON.parse(JSON.stringify(this.temp));
        this.setGrid(this.json);
        defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.header,
      });
      grid.records = this.json;
      // grid.listen(CLICK_CELL, (...args) => console.log(CLICK_CELL, args));
      this.setGrid = function(table = this.json) {
        grid.records = table;
      };
    },
  },

  created() {
    this.loadWeight();
  },
  mounted() {
    this.createGrid();
    TableWeightIndicator.gridKpiModal =(rec) =>{
      this.productPlainItemSelected = rec
      console.log('rec', rec)
      this.$bvModal.show('showProductPlainItem')
    },
    TableWeightIndicator.showModalGreatness =(rec) =>{
      this.productPlainItemSelected = rec
      console.log('rec', rec)
      this.$bvModal.show("showListGreatness")
    } 
  },
};
</script>

<style scoped>
.grid {
  height: calc(90vh - 220px);
  width: calc(100% - 16px);  
  border-radius: 4px;
  border: solid 1px rgba(0, 0, 0, 0.26);
  margin: auto;
  overflow-x: auto;
}

.row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
  margin-right: 15px;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.gridBtGroup {
  display: flex;
  justify-content: flex-end;
}

.ybase {
  /* margin-right: 20px; */
  margin-top: 20x;
}

img {
  max-height: 45px;
}

.spinner{
  color: #FF751B;
}

@media only screen and (max-width: 1247px) {
  .grid {
    width: 95%;
  }
}

@media only screen and (min-width: 1600px){
  .grid {
    height: calc(93vh - 220px);
  }
}
</style>